import React from 'react';
import {MetricsElement} from 'react-metrics';

import { Helpers } from '../../core/src/helpers';
import ProductPriceV2 from '../../product/components/product-price/product-price-v2';
import ProductCTA from '../../product/components/product-cta';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import Link from '../../shared/components/hyperlink';

import '../css/xsell-product-v2.less';

const XsellProductV2 = ({ product, className, productClickMetrics, ctaMetrics, baseProductSku, popupConfig, xsellType}) => {
	const imageSrc = Helpers.getCDNUrl(product.images[0].cdn, product.images[0].lrg);

	const link = (
		<Link className="xsell-item-header" to={product.linkUrl} target='_blank' title={product.name} {...productClickMetrics || {}}>
			<h3>{product.name}</h3>
		</Link>
	);
	return(
		<div className={`xsell-product${className ? ' ' + className : ''}`}>
			<ImageWithPlaceholder className='xsell-image-item' src={imageSrc} alt={product.name} />
			<div className='xsell-product-body'>
				{
					productClickMetrics && typeof productClickMetrics === 'object'
					? <MetricsElement>{link}</MetricsElement>
					: link
				}
				<div className='xsell-item-info'>
					<ProductPriceV2 product={product} className='xsell-prod-price' />
					<ProductCTA
                        product={product}
						enableAddToQuote={false}
						maintainSuccess={true}
                        isV2={true}
						ctaMetrics={ctaMetrics}
						baseProductSku={baseProductSku}
						xsellType={xsellType}
                    />
				</div>
			</div>
		</div>
	)
}

export default XsellProductV2;
